// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChangeMapType_changeMapTypeContainer__lbBs7 {
  position: absolute;
  bottom: 1rem;
  left: 0.6rem;
  z-index: 2;
  gap: 0.8em;
}
.ChangeMapType_containerToggle__shGOD {
  /* z-index: 1; */
  cursor: pointer;
  width: 5rem;
  height: 5rem;
  pointer-events: all;
}
`, "",{"version":3,"sources":["webpack://./src/components/Layers/ChangeMapType.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".changeMapTypeContainer {\n  position: absolute;\n  bottom: 1rem;\n  left: 0.6rem;\n  z-index: 2;\n  gap: 0.8em;\n}\n.containerToggle {\n  /* z-index: 1; */\n  cursor: pointer;\n  width: 5rem;\n  height: 5rem;\n  pointer-events: all;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"changeMapTypeContainer": `ChangeMapType_changeMapTypeContainer__lbBs7`,
	"containerToggle": `ChangeMapType_containerToggle__shGOD`
};
export default ___CSS_LOADER_EXPORT___;
